import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ApiMmlService} from "./api-mml.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [ApiMmlService]
})
export class ApiMmlModule { }
